import { render } from "./AlertDetail.vue?vue&type=template&id=a65029de&scoped=true&ts=true"
import script from "./AlertDetail.vue?vue&type=script&lang=ts"
export * from "./AlertDetail.vue?vue&type=script&lang=ts"

import "./AlertDetail.vue?vue&type=style&index=0&id=a65029de&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3687640787/src/biomass-frontend-pwc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a65029de"]])

export default __exports__